import { map } from 'rxjs/operators';

import { FIELD_HIDDEN_CLASS } from 'common/dynamic-form/utils/class-fields';

import { GeneralErrorProps } from './model/general-error-props.interface';

import { ISPFieldConfig, ISPFieldType, ISPFormState } from '../../model';

/**
 * Get props for general error field
 *
 * @param state - dynamic form state
 */
export function getGeneralErrorProps(state: ISPFormState): GeneralErrorProps {
  return {
    layoutPlace: 'header',
    order: 1,
    errorMsg$: state.validationService.generalErrorMsg$,
    isHidden: true,
    isHidden$: state.validationService.generalErrorMsg$.pipe(
      map(errorMsg => !errorMsg),
    ),
  };
}

/**
 * Get config for general error field
 *
 * @param state - dynamic form state
 */
export function getGeneralErrorConfig(
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.GeneralError> {
  const props = getGeneralErrorProps(state);

  return {
    type: ISPFieldType.GeneralError,
    props,
    expressions: {
      'props.isHidden': state.validationService.generalErrorMsg$.pipe(
        map(errorMsg => !errorMsg),
      ),
      className: state.validationService.generalErrorMsg$.pipe(
        map(errorMsg => (errorMsg ? '' : FIELD_HIDDEN_CLASS)),
      ),
    },
  };
}
